import React from "react"
import { Link } from "react-router-dom"

import { Section, SectionTitle, Text } from "@jewlr/storybook/info"
import { Box } from "components/common/index"
import { jewlr_t } from "helpers/application"

const PurePlay = () => (
  <Box mb={7}>
    <Section>
      <Box contain>
        <SectionTitle>
          Jewlr Named Pure Play Of The Year Award (Large) At The 2018 Canada
          Post E-Commerce Innovation Awards
        </SectionTitle>
        <Text>
          <strong>TORONTO, ONTARIO-- PRWeb - Sept. 28, 2018 -</strong> At a
          recent gala held at The Fairmont Royal York Hotel in Toronto,{" "}
          <Link data-lc="pureplay" to="/">
            Jewlr
          </Link>{" "}
          took home top honours in the{" "}
          <a
            href="https://canadapost.ca/ecommerceawards"
            rel="noopener noreferrer"
            target="_blank"
          >
            2018 Canada Post E-commerce Innovation Awards
          </a>
          . Recognized by the judging panel for its innovative business model in
          delivering {jewlr_t("terms.personalized")} {jewlr_t("terms.jewelry")}{" "}
          and for providing a superior online customer experience, Jewlr was
          named <em>Pure Play of the Year Award (Large)</em>. The category is
          focused completely on the e-commerce channel, and pays tribute to the
          online shopping experience that is most engaging and effective. Jewlr
          will receive $100,000 in free {jewlr_t("terms.shipping")} as well as
          valuable marketing prize packages.
        </Text>
        <Text>
          Jewlr has successfully revolutionized the {jewlr_t("terms.jewelry")}{" "}
          shopping experience by offering customers the power of
          personalization. The company custom makes{" "}
          {jewlr_t("terms.personalized")} {jewlr_t("terms.jewelry")} – including{" "}
          <Link data-lc="pureplay" to="/birthstone-rings">
            Birthstone Rings
          </Link>
          ,{" "}
          <Link data-lc="pureplay" to="/engagement-rings-landing">
            Engagement Rings
          </Link>
          ,{" "}
          <Link data-lc="pureplay" to="/name-necklaces">
            Name Necklaces
          </Link>
          ,{" "}
          <Link data-lc="pureplay" to="/bracelets">
            Bracelets
          </Link>{" "}
          and{" "}
          <Link data-lc="pureplay" to="/mens-rings">
            Men&apos;s Rings
          </Link>{" "}
          – and {jewlr_t("terms.ships")} direct at below retail prices within a
          few days. By combining design technology, 3D printing and traditional
          handmade techniques, Jewlr is able to deliver high quality, stylish,
          {jewlr_t("terms.personalized")} {jewlr_t("terms.jewelry")} for every
          occasion. Customers select a style, choose from solid sterling silver,
          white, yellow or rose gold, genuine or simulated gemstones, and add
          engravings. All Jewlr customers enjoy exceptional customer service,
          free {jewlr_t("terms.shipping")} and a free gift. Customer
          satisfaction is backed by a 99-day &quot;hassle-free&quot; returns
          policy.
        </Text>
        <Text>
          &quot;There was some amazing talent in this award category from some
          of the largest brand retailers in the Canadian marketplace. We are
          thrilled to win this award,&quot; said Tony Davis, Founder, Jewlr.
          &quot;Every facet of Jewlr has been designed with the goal of creating
          an innovative shopping experience for consumers to create{" "}
          {jewlr_t("terms.personalized")} {jewlr_t("terms.jewelry")}, at below
          retail prices with stellar customer service and free delivery in a
          matter of days.&quot;
        </Text>
        <Text>
          The judging panel included: Stéphanie Aubin, Retail Council of Canada;
          Mohit Grover, Google Canada; Jennifer Lee, Deloitte Canada; Sucharita
          Mulpuru-Kodali, Forrester Research; Blake Smith, Facebook.
        </Text>
        <Text>
          <strong>About the Canada Post E-commerce Innovation Awards</strong>
        </Text>
        <Text>
          The Canada Post E-commerce Innovation Awards were created to recognize
          and reward the country&apos;s leading online retailers. Finalists,
          which range from large traditional retailers to small start-ups,
          compete across categories that span omni-channel innovation, online
          customer experience, brand engagement and social impact. Chosen by an
          independent panel of expert judges, winners receive up to $100,000 in
          free {jewlr_t("terms.shipping")}, a Smartmail™ marketing prize package
          worth up to $50,000 and a customized marketing package worth up to
          $15,000. For more information visit{" "}
          <a href="https://canadapost.ca/ecommerceawards">
            canadapost.ca/ecommerceawards.
          </a>
        </Text>
        <Text>
          <strong>About Canada Post</strong>
        </Text>
        <Text>
          Canada Post is the country&apos;s No. 1 parcel company, delivering
          nearly two of every three parcels that Canadian consumers order
          online. It reaches 16.2 million addresses, operates the country&apos;s
          largest retail network, and offers affordable and reliable service
          with convenient pickup and return options for online shoppers.
          Together, Canada Post, Purolator Holdings Ltd. and SCI Group Inc.
          offer market-leading end-to-end solutions for e-commerce shippers by
          leveraging the assets and expertise of the Canada Post Group of
          Companies.
        </Text>
        <Text>
          For more information, visit{" "}
          <a href="https://www.canadapost.ca/cpc/en/home.page">canadapost.ca</a>
        </Text>
        <Text>
          <strong>About Jewlr</strong>
        </Text>
        <Text>
          Jewlr is a leading online {jewlr_t("terms.jewelry")} retailer
          specializing in the design and manufacturing of{" "}
          {jewlr_t("terms.personalized")} {jewlr_t("terms.jewelry")}. Founded in
          2009 by Internet entrepreneurs, Jewlr has transformed the{" "}
          {jewlr_t("terms.jewelry")} shopping experience by using the latest web
          technology to give customers the ability to create and instantly
          preview custom {jewlr_t("terms.jewelry")}. Every Jewlr item is then
          custom manufactured using 3D printing and traditional hand crafting to
          deliver high quality {jewlr_t("terms.personalized")}{" "}
          {jewlr_t("terms.jewelry")} in just a few days. Additional information
          is available at <a href="https://www.jewlr.com">jewlr.com</a>. On
          Social: <a href="https://instagram.com/jewlr">Instagram</a> and{" "}
          <a href="https://www.facebook.com/jewlrcom/">Facebook.</a>
        </Text>
      </Box>
    </Section>
  </Box>
)
export default PurePlay
